import React from 'react';

import Grid from '@material-ui/core/Grid';

import styles from './modesview.module.css';

import SVGDonutChart from "./donutchart";
import SkullRatio from "./skullratio";
import KillsPerWeapon from "./killsperweapon";

import Box from '@material-ui/core/Box';
import InfoContainer from "./container/InfoContainer";
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { createMuiTheme, useTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Translation } from "react-i18next";

export default function IndexUserRatiosView(props) {

    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down('xs'));  

    //console.log(props.details);

    if(mobileView){
        return (
            <div>

                {showMobileView(props)}

            </div>
        );
    }else{
        return (
            <div>

                {showDesktopView(props)}

            </div>
        );
    }

}

    function showWinRate(props){

        // false is win rate
        const wins = (props && props.details && props.details.WIN_CNT) ? props.details.WIN_CNT : 0;
        const games = (props && props.details && props.details.LOSE_CNT) ? props.details.LOSE_CNT : 0;

        //console.log('games', games);
        //console.log('wins', wins);

        var myWinRate = <SVGDonutChart dividend={games} divisor={wins} type={false} />
        //var title = 'Win Rate';

        var myModeChild = <Box className={styles.allRatiosViewBox}>{myWinRate}</Box>

        return (
            <Translation>
            {
                (t) =>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                    <div className={styles.allModesViewtitle}>{t('Win Rate')}</div>

                    {myModeChild}

                </Grid>            
            }
            </Translation>    
        );

        /*
        return <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                    <InfoContainer
                        headerLeft = {title}
                        headerRight = {null}
                        footer = {null} 
                        children = {myWinRate}
                        />
                </Grid> 
        // */
    }
      
    function showKDR(props){
      
        // true is kill death rate
        const kills = (props && props.details && props.details.ENEMY_KILL_CNT) ? props.details.ENEMY_KILL_CNT : 0;
        const deaths = (props && props.details && props.details.DEATH_CNT) ? props.details.DEATH_CNT : 0;

        //console.log('kills', kills);
        //console.log('deaths', deaths);

        var myKillRate = <SVGDonutChart dividend={deaths} divisor={kills} type={true} />;
        //var title = 'Kill-Death Ratio';
        var myModeChild = <Box className={styles.allRatiosViewBox}>{myKillRate}</Box>

        /**/
        return (
            <Translation>
            {
                (t) =>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                    <div className={styles.allModesViewtitle}>{t('Kill-Death Ratio')}</div>

                    {myModeChild}

                </Grid>
            }
            </Translation>     
        );
        // */

        /*
        return (<InfoContainer
                        headerLeft = {title}
                        headerRight = {null}
                        footer = {null} 
                    >
                        {myModeChild}
                    </InfoContainer>
                );
        // */ 
    }

    function showKPW(props){

        /*
          RIFLE_KILL - assault rifle
          SHOT_KILL - sniper
          SMG_KILL - sub machine gun
          HEAVY_KILL - machine gun
          SHOTGUN_KILL - shotgun
          PISTOL_KILL - pistol
          KNIFE_KILL - melee
          DRAW_KILL - grenades
        */
      /**/
      
        const RIFLE_KILL = (props && props.details && props.details.RIFLE_KILL) ? props.details.RIFLE_KILL : 0;
        const SHOT_KILL = (props && props.details && props.details.SHOT_KILL) ? props.details.SHOT_KILL : 0;
        const SMG_KILL = (props && props.details && props.details.SMG_KILL) ? props.details.SMG_KILL : 0;
        const HEAVY_KILL = (props && props.details && props.details.HEAVY_KILL) ? props.details.HEAVY_KILL : 0;
        const SHOTGUN_KILL = (props && props.details && props.details.SHOTGUN_KILL) ? props.details.SHOTGUN_KILL : 0;
        const PISTOL_KILL = (props && props.details && props.details.PISTOL_KILL) ? props.details.PISTOL_KILL : 0;
        const KNIFE_KILL = (props && props.details && props.details.KNIFE_KILL) ? props.details.KNIFE_KILL : 0;
        const DRAW_KILL = (props && props.details && props.details.DRAW_KILL) ? props.details.DRAW_KILL : 0;
      
        /*
        return <KillsPerWeapon 
                    rifle={RIFLE_KILL}
                    sniper={SHOT_KILL}
                    smg={SMG_KILL}
                    mg={HEAVY_KILL}
                    shotgun={SHOTGUN_KILL}
                    pistol={PISTOL_KILL}
                    melee={KNIFE_KILL}
                    grenade={DRAW_KILL}
              />
        // */
      
        var kpwChild = <KillsPerWeapon 
                          rifle={RIFLE_KILL}
                          sniper={SHOT_KILL}
                          smg={SMG_KILL}
                          mg={HEAVY_KILL}
                          shotgun={SHOTGUN_KILL}
                          pistol={PISTOL_KILL}
                          melee={KNIFE_KILL}
                          grenade={DRAW_KILL}
                        />

        //var title = 'Kills Per Weapon';
        var myModeChild = <Box className={styles.allRatiosViewBox}>{kpwChild}</Box>

        return (
            <Translation>
            {
                (t) =>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                    <div className={styles.allModesViewtitle}>{t('Kills Per Weapon')}</div>

                    {myModeChild}

                </Grid>
            }
            </Translation>     
        );

        /*
        return <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                    <InfoContainer
                        headerLeft = {title}
                        headerRight = {null}
                        footer = {null} 
                        children = {kpwChild}
                        />
                </Grid>     
        */   
    }

    function showSkulls(props){

        const headshots = (props && props.details && props.details.HEADSHOT_KILL_CNT) ? props.details.HEADSHOT_KILL_CNT : 0;
        const kills = (props && props.details && props.details.ENEMY_KILL_CNT) ? props.details.ENEMY_KILL_CNT : 0;       

        var mySkullRate = <SkullRatio headshots={headshots} kills={kills} />;
        //var title = 'Headshot Rate';
        var myModeChild = <Box className={styles.allRatiosViewBox}>{mySkullRate}</Box>

        return (
            <Translation>
            {
                (t) =>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                    <div className={styles.allModesViewtitle}>{t('Headshot Rate')}</div>

                    {myModeChild}

                </Grid>
            }
            </Translation>          
        );

        /*
        return <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                    <InfoContainer
                        headerLeft = {title}
                        headerRight = {null}
                        footer = {null} 
                        children = {mySkullRate}
                        />
                </Grid>
        */
    }
      

    function showDesktopView(props){
        return(
                <Grid container spacing={2} alignItems="stretch">

                    {showWinRate(props)}
                    {showKDR(props)}
                    {showSkulls(props)}
                    {showKPW(props)}

                </Grid>

        );
    }

    function showMobileView(props){

        // react slider
        var settings = {
            dots: true,
            arrows: false,
            infinite: true,
            centerMode: true,
            centerPadding: '12px',
            slidesToShow: 1,
            slidesToScroll: 1
            //,dotsClass: 'mobileSlickDots'
        };

        return (
            
            <div className={styles.allModesViewContainer}>
                <Slider {...settings} style={{position: 'relative'}}>
                    <div className={styles.sliderBoxWidth}>{showWinRate(props)}</div>
                    <div className={styles.sliderBoxWidth}>{showKDR(props)}</div>
                    <div className={styles.sliderBoxWidth}> {showSkulls(props)}</div>
                    <div className={styles.sliderBoxWidth}>{showKPW(props)}</div>
                </Slider>
            </div>
        );
    }    
